import React from 'react';
import { FadeIn } from './FadeIn';
import { SmartphoneIcon, DatabaseIcon, LayersIcon, ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
export function PlatformArchitecture() {
  return <section className="py-24 bg-navy relative" data-id="element-229" data-mp="3b9e55s066x2g">
      <div className="max-w-7xl mx-auto px-6" data-id="element-230" data-mp="3b82v5ag4st2w">
        <FadeIn className="text-center mb-16" data-id="element-231" data-mp="36bceakwi5tgf">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-232" data-mp="36ajhabnciibh">
            Built to Integrate. Designed to Scale.
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-233" data-mp="2wl9loltamhim">
            A frictionless architecture that sits securely between your core
            systems and your customers.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-234" data-mp="2nl4fgezu5p61">
          <div className="max-w-4xl mx-auto relative" data-id="element-235" data-mp="2nlwb1ptfnmwb">
            {/* Top Layer: Digital Channels */}
            <div className="bg-slate border border-white/10 rounded-xl p-6 text-center relative z-10 shadow-lg" data-id="element-236" data-mp="2ikp05hvzu7lf">
              <div className="flex items-center justify-center gap-3 mb-2 text-white" data-id="element-237" data-mp="2do8fixo06bd3">
                <SmartphoneIcon className="w-6 h-6 text-blue" data-id="element-238" data-mp="1v0pc3v9iucb" />
                <h3 className="text-xl font-semibold" data-id="element-239" data-mp="6na9t4dlz277">
                  Your Brand & Digital Channels
                </h3>
              </div>
              <p className="text-sm text-gray-400" data-id="element-240" data-mp="3oyx230du434z">
                Web, Mobile App, API Consumers
              </p>
            </div>

            {/* Connecting Lines Down */}
            <div className="flex justify-center py-4 relative" data-id="element-241" data-mp="llm5b7p8w4ws">
              <div className="w-px h-12 bg-gradient-to-b from-blue/50 to-teal/50 relative" data-id="element-242" data-mp="pmegw7llalw8">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-blue animate-ping" data-id="element-243" data-mp="bmdeuotl98f6"></div>
                <ArrowDownIcon className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-4 h-4 text-teal" data-id="element-244" data-mp="gk59vrpj5anl" />
              </div>
            </div>

            {/* Middle Layer: FIQIS Platform */}
            <div className="bg-gradient-to-br from-teal/10 to-blue/5 border border-teal/30 rounded-2xl p-8 relative z-10 shadow-[0_0_50px_rgba(0,212,170,0.1)]" data-id="element-245" data-mp="31bp7bce18ch7">
              <div className="absolute -top-3 left-8 bg-navy px-3 text-xs font-bold tracking-widest text-teal uppercase border border-teal/30 rounded-full" data-id="element-246" data-mp="2d7pmu06ya25u">
                FIQIS Platform
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4" data-id="element-247" data-mp="23i636sbey49x">
                {['Secure Integration', 'AI Intelligence', 'Micro-Lending', 'Embedded P2P'].map((module, i) => <div key={i} className="bg-navy/80 backdrop-blur-sm border border-white/10 rounded-lg p-4 text-center hover:border-teal/50 transition-colors cursor-default group" data-id="element-248" data-mp="1tm32zs04gfpm" data-mpi={i}>
                    <LayersIcon className="w-5 h-5 text-teal mx-auto mb-2 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-249" data-mp="3jwfsppre5z2c" />
                    <span className="text-sm font-medium text-white" data-id="element-250" data-mp="3exmfzzjxic38">
                      {module}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Connecting Lines Down */}
            <div className="flex justify-center py-4 relative" data-id="element-251" data-mp="19kvqdyox6y">
              <div className="w-px h-12 bg-gradient-to-b from-teal/50 to-white/20 relative" data-id="element-252" data-mp="34512hesl9z">
                <ArrowUpIcon className="absolute -top-3 left-1/2 -translate-x-1/2 w-4 h-4 text-teal" data-id="element-253" data-mp="4zb4ccfauyiy" />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-white/50 animate-ping" style={{
                animationDelay: '1s'
              }} data-id="element-254" data-mp="33jughwvrfqj2"></div>
              </div>
            </div>

            {/* Bottom Layer: Core Systems */}
            <div className="bg-slate border border-white/10 rounded-xl p-6 text-center relative z-10 shadow-lg" data-id="element-255" data-mp="sq830ni33zc9">
              <div className="flex items-center justify-center gap-3 mb-2 text-white" data-id="element-256" data-mp="wqij4szlc64u">
                <DatabaseIcon className="w-6 h-6 text-gray-400" data-id="element-257" data-mp="v9l8silt28ma" />
                <h3 className="text-xl font-semibold" data-id="element-258" data-mp="vbxyjhxt1n9w">
                  Core Banking Systems & Third Parties
                </h3>
              </div>
              <p className="text-sm text-gray-400" data-id="element-259" data-mp="159c24gymqhks">
                Legacy Cores, Payment Gateways, Identity Providers
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}